import { isEmptyObject } from 'jquery';
import { $body } from '../globals.js';

//
var showAnswer = function ($activity) {
    if ($activity.data('show-answer')) {
        $activity.addClass('show-answer');
    }
};

//
var showRowAnswer = function ($row) {
    
    console.log('show row answer', $row)
    //add correct answer to undeneath the question
    var $item = $row,
        $options = $item.find('.dropdown-menu'),
        $answer = $options.attr('data-required-index').length > 1 ? $options.attr('data-required-index').split(',') : Array($options.attr('data-required-index')),
        $text = $options.find('[data-index="' + $answer[0] + '"]').text();

    $row.find('.question').append('<p class="answered">' + $text + '</p>' );
    //setAsComplete($activity);

};
//
var setAsComplete = function ($activity) {
    showAnswer($activity);
    rebus.panels.setActivityAsComplete($activity, true);
};
// get activity result
var getResult = function ($activity) {
    var result = true,
        tempResult;
    $('[data-required-index]', $activity).each(function () {
        // check if multiple correct options and split
        // make array even for single options
        // will only work for 0-9
        var ri = $(this).attr('data-required-index').length > 1 ? $(this).attr('data-required-index').split(',') : Array($(this).attr('data-required-index'));

        tempResult = ri.includes($(this).attr('data-selected-index'));
        
        //add in tick or cross
        var elem = document.createElement("img");

        elem.setAttribute("src", "content/images/icons/dd_" + (tempResult ? 'correct' : 'incorrect') + ".svg");
        elem.setAttribute("class", "w-100 img-fluid correctness-icon");

        var $item = $(this).closest('.row');
            $item.find('.correctness-indicator').get(0).appendChild(elem);

        if(!tempResult){
            $item.find('.dropdown-toggle').addClass('disabled').attr('aria-disabled', true).attr('disabled', true);
            showRowAnswer($item);
            result = false;
        }else{
            
        }
        //return result;
    });
    $activity.addClass('activity-'+(result ? 'correct' : 'incorrect'));
    return result;
}

export default {
    dispose: function(){

    },
    init: function (partial) {
        var _this = this;
        // reset
        var reset = function ($activity) {
            // reset the label
            $('[data-original-label]', $activity).each(function () {
                $(this).html($(this).attr('data-original-label'));
            });
            // reset the selected index
            $('[data-selected-index]', $activity).each(function () {
                $(this).attr('data-selected-index', '');
            });
            // enable all options again
            $('li[data-index]', $activity).removeClass('disabled');
            $('li[data-index] > a', $activity).removeAttr('aria-disabled');
            //
            $($activity).attr('data-correct', '');
            $('.response-text', $activity).html('');

            //clear the correct/incorrect images
            $('.correctness-indicator', $activity).empty();

            // store the state
            rebus.stateHelper.setElementState($activity, storeResponses(), null);
            rebus.stateHelper.save();
            toggleReset($activity);
            toggleSubmit($activity);
        };

        var showAnswers = function ($activity) {
            
            //add correct answer to undeneath the question
            $('.question', $activity).each(function () {
                var $item = $(this).closest('.row'),
                    $options = $item.find('.dropdown-menu'),
                    $answer = $options.attr('data-required-index').length > 1 ? $options.attr('data-required-index').split(',') : Array($options.attr('data-required-index')),
                    $text = $options.find('[data-index="' + $answer[0] + '"]').text();

                $(this).append('<p class="answered">' + $text + '</p>' );
                setAsComplete($activity);
            });
        };

        // submit
        var submit = function ($activity, announce) {
            var result, $responses, $response, user_responses = [], correct_responses = [];
            result = getResult($activity);
            $responses = $activity.data('responses');
            $activity.attr('data-correct', result === true ? true : false);
            $response = (result === true ? 'correct' : 'incorrect');
            $response = $responses[$response];
            $activity.data('$fb').liveFeedback('value', $response, {
                silent: !announce
            });
            /* if ( $activity.data('mandatory') === 'partial' || result) {
                setAsComplete($activity);
            } */
            setAsComplete($activity);
            rebus.stateHelper.save();

            //toggleReset($activity);
            var $resetbtn = $('.btn-reset-drop-down-question', $activity);
            if(!result){
                $resetbtn.hide();
            }

            toggleSubmit($activity);

            if(announce) {
                // scroll to feedback
                var $responsecontainer = $activity.find('.response');
                rebus.utils.scrollTo( $responsecontainer );
                $responsecontainer[0].focus();
            }

            //if correct or incorrect?

            // Track interaction (if supported)
            // Build responses
            /* $activity.find( '[data-selected-index]' ).each( function () {
                var $this = $( this ),
                    short = $this.data('selectedIndex'),
                    $selected = $this.find('li[data-index]').get( short ),
                    long = $selected.find( 'a' ).text().replaceAll(/\s+/g,'-');
                user_responses.push( Track.getScormVersion() == '1_2' ? short : long); //CreateResponseIdentifier( short, long );
            } );
            $activity.find( '[data-required-index]' ).each( function () {
                var $this = $( this ),
                    short = $this.data('requiredIndex'),
                    $selected = $this.find('li[data-index]').get( short ),
                    long = $selected.find( 'a' ).text().replaceAll(/\s+/g,'-');
                correct_responses.push( Track.getScormVersion() == '1_2' ? short : long); //CreateResponseIdentifier( short, long );
            } ); */
            // Trackem!
            // var details = rebus.stateHelper.getElementDetails($activity);
            //RecordMultipleChoiceInteraction( details.storeId, responses, result, correct_responses, $activity.find('.question-text').text(), null, null, null );
        };

        // toggle reset
        var toggleReset = function ($activity) {
            var $resetbtn = $('.btn-reset-drop-down-question', $activity);
            var $disabled = $('[data-selected-index=""]', $activity).length === $('[data-selected-index]', $activity).length;
            $resetbtn.attr('aria-disabled', $disabled).attr('disabled', $disabled);
        };

        // toggle submit
        var toggleSubmit = function ($activity) {
            var $submitbtn = $('.btn-check-drop-down-question', $activity);
            var $answered = (typeof $($activity).attr('data-correct') !== "undefined" && $($activity).attr('data-correct') !== "");
            var $disabled = ($('[data-selected-index=""]', $activity).length !== 0 || $answered);
            $submitbtn.attr('aria-disabled', $disabled).attr('disabled', $disabled);
        };

        // store responses
        var storeResponses = function ($activity) {
            var $responses = [];
            $('[data-selected-index]', $activity).each(function () {
                $responses.push($(this).attr('data-selected-index'));
            });
            return $responses.join();
        }
        //
        $('[data-activity="drop-down"]').each(function () {
            var $activity = $(this),
                details = rebus.stateHelper.getElementDetails($activity),
                selections = details.state;

            // submit button
            var $submitbtn = $('.btn-check-drop-down-question', $activity);
            $submitbtn.on('click', function () {
                submit($activity, true);
            }).attr('aria-disabled', true).attr('disabled', true);

            // reset button
            var $resetbtn = $('.btn-reset-drop-down-question', $activity);
            $resetbtn.on('click', function () {
                reset($activity, true);
            }).attr('aria-disabled', true).attr('disabled', true);
            //
            var $responses = {};
            $activity.data('responses', $responses);
            $('[data-response]', $activity).each(function () {
                var $response = $(this);
                $responses[$response.attr('data-response')] = $response.html();
                $response.remove();
            });
            var $response = $([
                '<div class="response" tabindex="-1">',
                    '<div>',
                        '<div class="response-text" aria-live="assertive" aria-atomic="false"></div>',
                    '</div>',
                '</div>'
            ].join('\n'));
            $('[data-drop-down-submit]', $activity).after($response);
            $activity.data('$fb', $('.response-text', $response).liveFeedback());
            if (selections) {
                var $complete = true;
                var selectedindexes = selections.split(',');
                var $index, $label;
                $('[data-selected-index]', $activity).each(function (ix, el) {
                    $index = selectedindexes[ix];
                    $('li[data-index="' + $index + '"]', $activity).addClass('disabled');
                    $(this).attr('data-selected-index', $index);
                    // now set the label
                    if ($index + "" !== "") {
                        $label = $('[data-index="' + $index + '"] > a', this).html();
                        $(this).closest('.btn-group').find('[data-original-label]').html($label);
                    }else{
                        $complete = false;
                    }
                    toggleReset($activity);
                    toggleSubmit($activity);
                });

                if($activity.hasClass('activity-done')){
                    submit($activity, true);
                    return;
                }

                if($activity.hasClass('activity-started')){
                    console.log('activity started')
                    getResult($activity);
                    $resetbtn.hide();
                    $submitbtn.hide();
                }

                // 
                rebus.panels.markActivityAsStarted($activity);

            }
            
            //on load check if activity has been answered fully
            if($activity.hasClass('activity-started')){
                console.log('activity started')
                getResult($activity);
                $resetbtn.hide();
                $submitbtn.hide();
            }

            // loop through each drop down and shuffle
            $('.dropdown-menu', $activity).each(function(){
                var menu = $(this);
                _this.shuffle($('.dropdown-item', menu));
            })
            
        });

        if (partial) {
            return;
        }
        
        var $selector = '[data-activity="drop-down"] .dropdown-menu a';
        $body.on('click', $selector, function () {
            var $this = $(this);
            // is this button disabled?
            if($this.attr('aria-disabled')+"" === "true") return;
            // continue
            var $activity = $(this).closest('[data-activity="drop-down"]');
            // get the current selected index and enable elements
            var $lastindex = $this.closest('[data-selected-index]').attr('data-selected-index');
            // enabled all elements with the same index
            $('li[data-index="' + $lastindex + '"]', $activity).removeClass('disabled');
            $('li[data-index="' + $lastindex + '"] > a', $activity).removeAttr('aria-disabled');
            // get this index
            var $index = $this.closest('li').attr('data-index');
            $this.closest('.dropdown-menu').attr('data-selected-index', $index);
            
            // disabled all elements with the same index
            //$('li[data-index="' + $index + '"]', $activity).addClass('disabled');
            //$('li[data-index="' + $index + '"] > a', $activity).attr('aria-disabled',true);

            // add this index to the selected index
            $this.closest('[data-selected-index]').attr('data-selected-index', $index);
            // add the value to the .selected-label
            $this.closest('.btn-group').find('.selected-label').html($this.html());
            // state manager
            rebus.stateHelper.setElementState($activity, storeResponses(), null);
            rebus.panels.markActivityAsStarted($activity);
            // enable/disabled submit
            toggleSubmit($activity);
            // enable/disabled reset
            toggleReset($activity);
            // send the focus back to itself
            $this.closest('.btn-group').find('button')[0].focus();
        }).on('focus', $selector, function () {
            var $area = $(this);
            $area.closest('[data-activity]').find('.click-area-focus').eq($area.data('idx')).addClass('active');
        }).on('blur', $selector, function () {
            var $area = $(this);
            $area.closest('[data-activity]').find('.click-area-focus').eq($area.data('idx')).removeClass('active');
        });

    },
    getResult: getResult,
    shuffle:  function($items){
        var container = $items.parent().get(0);
        for (var i = $items.length; i >= 0; i--) {
            container.appendChild(container.children[Math.random() * i | 0]);
        }
   }
};



